import { RetailPageType } from '../common';

import getItemGroupByProductGroup from './consumer-srories/getItemGroupByProductGroup';

export type Option = {
  value: string;
  label: string;
};

export enum FilterKeys {
  PRODUCT_GROUP,
  COUNTRY,
}

export type Filters = {
  filterKey: FilterKeys;
  options: Option[];
};

export type SelectedFilters = {
  pageType: RetailPageType;
  selectedFilters: Filters[];
};

export const getRetailMarketFromFilters = (
  appliedFilters: SelectedFilters[],
  pageType?: RetailPageType
): { itemGroup: string; country: string } => {
  const market = { itemGroup: '', country: '' };
  const selectedFilters: Filters[] = appliedFilters.find(
    (filter: SelectedFilters) => filter.pageType === pageType
  )?.selectedFilters;
  if (!selectedFilters) {
    return market;
  }

  const productGroupOptions = selectedFilters.find(
    (filter: Filters) => filter.filterKey === FilterKeys.PRODUCT_GROUP
  )?.options;
  const countryOptions = selectedFilters.find((filter: Filters) => filter.filterKey === FilterKeys.COUNTRY)?.options;
  if (productGroupOptions?.length > 0) {
    market.itemGroup = getItemGroupByProductGroup(productGroupOptions[0].value) ?? '';
  }
  if (countryOptions?.length > 0) {
    market.country = countryOptions[0].value ?? '';
  }

  return market;
};
